import React from 'react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';

export const RegistrationModal = ({ registrationForm, setRegistrationForm, otpSent, handleGenerateOTP, handleRegisterABHA, onClose }) => (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-xl max-w-md w-full p-6 max-h-[90vh] overflow-y-auto">
      <h3 className="text-xl font-bold mb-4">Create ABHA (Health ID)</h3>
      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">First Name *</label>
            <Input value={registrationForm.first_name} onChange={(e) => setRegistrationForm({...registrationForm, first_name: e.target.value})} placeholder="First name" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Last Name *</label>
            <Input value={registrationForm.last_name} onChange={(e) => setRegistrationForm({...registrationForm, last_name: e.target.value})} placeholder="Last name" />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Date of Birth *</label>
          <Input type="date" value={registrationForm.date_of_birth} onChange={(e) => setRegistrationForm({...registrationForm, date_of_birth: e.target.value})} />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Gender *</label>
          <select value={registrationForm.gender} onChange={(e) => setRegistrationForm({...registrationForm, gender: e.target.value})} className="w-full p-2 border rounded-lg">
            <option value="M">Male</option>
            <option value="F">Female</option>
            <option value="O">Other</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Mobile Number *</label>
          <div className="flex gap-2">
            <Input value={registrationForm.mobile} onChange={(e) => setRegistrationForm({...registrationForm, mobile: e.target.value})} placeholder="10-digit mobile" maxLength={10} />
            {!otpSent && <Button onClick={handleGenerateOTP} disabled={registrationForm.mobile.length !== 10}>Send OTP</Button>}
          </div>
        </div>
        {otpSent && <div className="bg-green-50 p-3 rounded-lg text-sm text-green-700">OTP sent! Use demo OTP: 123456</div>}
      </div>
      <div className="flex gap-3 mt-6">
        <Button variant="outline" onClick={onClose} className="flex-1">Cancel</Button>
        <Button className="flex-1 bg-green-600 hover:bg-green-700" onClick={handleRegisterABHA} disabled={!otpSent}>Create ABHA</Button>
      </div>
    </div>
  </div>
);

export const LinkingModal = ({ linkForm, setLinkForm, handleLinkABHA, onClose }) => (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-xl max-w-md w-full p-6">
      <h3 className="text-xl font-bold mb-4">Link Existing ABHA</h3>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">ABHA Number</label>
          <Input value={linkForm.abha_number} onChange={(e) => setLinkForm({...linkForm, abha_number: e.target.value})} placeholder="XX-XXXX-XXXX-XXXX" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">ABHA Address</label>
          <Input value={linkForm.abha_address} onChange={(e) => setLinkForm({...linkForm, abha_address: e.target.value})} placeholder="username@abdm" />
        </div>
      </div>
      <div className="flex gap-3 mt-6">
        <Button variant="outline" onClick={onClose} className="flex-1">Cancel</Button>
        <Button className="flex-1 bg-green-600 hover:bg-green-700" onClick={handleLinkABHA}>Link ABHA</Button>
      </div>
    </div>
  </div>
);

export const ClaimFormModal = ({ claimForm, setClaimForm, eligibility, handleSubmitClaim, onClose }) => (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-xl max-w-lg w-full p-6 max-h-[90vh] overflow-y-auto">
      <h3 className="text-xl font-bold mb-4">Submit Ayushman Bharat Claim</h3>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">Claim Type</label>
          <select value={claimForm.claim_type} onChange={(e) => setClaimForm({...claimForm, claim_type: e.target.value})} className="w-full p-2 border rounded-lg">
            <option value="preauth">Pre-Authorization</option>
            <option value="claim">Final Claim</option>
            <option value="enhancement">Enhancement Request</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Package</label>
          <select value={claimForm.package_code} onChange={(e) => {
            const pkg = eligibility?.covered_packages?.find(p => p.code === e.target.value);
            setClaimForm({ ...claimForm, package_code: e.target.value, package_name: pkg?.name || '' });
          }} className="w-full p-2 border rounded-lg">
            {eligibility?.covered_packages?.map(pkg => (
              <option key={pkg.code} value={pkg.code}>{pkg.name} (Up to &#8377;{pkg.limit.toLocaleString()})</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Estimated Amount (&#8377;)</label>
          <Input type="number" value={claimForm.estimated_amount} onChange={(e) => setClaimForm({...claimForm, estimated_amount: parseFloat(e.target.value)})} />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Primary Diagnosis (ICD-10)</label>
          <Input value={claimForm.diagnosis_codes[0]} onChange={(e) => setClaimForm({...claimForm, diagnosis_codes: [e.target.value]})} placeholder="e.g., I10 for Hypertension" />
        </div>
        <div className="bg-blue-50 p-3 rounded-lg text-sm text-blue-700">
          <p className="font-medium">Demo Mode</p>
          <p>Pre-authorization requests will be auto-approved at 90% of estimated amount.</p>
        </div>
      </div>
      <div className="flex gap-3 mt-6">
        <Button variant="outline" onClick={onClose} className="flex-1">Cancel</Button>
        <Button className="flex-1 bg-green-600 hover:bg-green-700" onClick={handleSubmitClaim}>Submit Claim</Button>
      </div>
    </div>
  </div>
);
